export const MAX_ATTACH_BYTES = 25 * 1024 * 1024;

export function formatBytes(n) {
  const size = Number(n) || 0;
  if (size < 1024) return `${size} B`;
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(0)} KB`;
  return `${(size / (1024 * 1024)).toFixed(1)} MB`;
}

export function senderName(from) {
  const raw = String(from || '').trim();
  const quoted = raw.match(/^"?([^"<]+)"?\s*</);
  if (quoted) return quoted[1].trim();
  if (raw.includes('@')) return raw.split('@')[0];
  return raw || '—';
}

export function senderInitial(from) {
  const name = senderName(from);
  const ch = name.replace(/[^A-Za-zÀ-ÿ0-9]/g, '').charAt(0);
  return (ch || '?').toUpperCase();
}

export function formatWhen(internalDate, dateHeader) {
  const d = internalDate ? new Date(Number(internalDate)) : dateHeader ? new Date(dateHeader) : null;
  if (!d || Number.isNaN(d.getTime())) return dateHeader || '';
  const now = new Date();
  const sameDay = d.toDateString() === now.toDateString();
  if (sameDay) return d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  return d.toLocaleDateString('pt-BR', { day: '2-digit', month: 'short' });
}

export function formatFullDate(dateHeader, internalDate) {
  const d = dateHeader ? new Date(dateHeader) : internalDate ? new Date(Number(internalDate)) : null;
  if (!d || Number.isNaN(d.getTime())) return dateHeader || '';
  return d.toLocaleString('pt-BR', {
    weekday: 'long',
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function fileKind(mime, name) {
  const m = String(mime || '').toLowerCase();
  const n = String(name || '').toLowerCase();
  if (m.includes('pdf') || n.endsWith('.pdf')) return 'pdf';
  if (m.startsWith('image/') || /\.(png|jpe?g|gif|webp)$/.test(n)) return 'image';
  if (m.includes('sheet') || m.includes('excel') || /\.(xlsx?|csv)$/.test(n)) return 'sheet';
  if (m.includes('word') || /\.(docx?)$/.test(n)) return 'doc';
  return 'file';
}

export function canPreview(kind) {
  return kind === 'pdf' || kind === 'image';
}

export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const data = String(reader.result || '');
      const comma = data.indexOf(',');
      resolve(comma >= 0 ? data.slice(comma + 1) : data);
    };
    reader.onerror = () => reject(new Error(`Não foi possível ler ${file.name}`));
    reader.readAsDataURL(file);
  });
}

export function stripHtml(html) {
  return String(html || '')
    .replace(/<style[\s\S]*?<\/style>/gi, ' ')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/** Converte classes do Quill em estilos inline para clientes de e-mail. */
export function quillHtmlToInline(html) {
  if (!html || typeof document === 'undefined') return html || '';
  const wrap = document.createElement('div');
  wrap.innerHTML = html;
  wrap.querySelectorAll('[class]').forEach((el) => {
    const cls = String(el.className || '');
    const styles = [];
    if (cls.includes('ql-align-center')) styles.push('text-align:center');
    if (cls.includes('ql-align-right')) styles.push('text-align:right');
    if (cls.includes('ql-align-justify')) styles.push('text-align:justify');
    const indent = cls.match(/ql-indent-(\d+)/);
    if (indent) styles.push(`padding-left:${Number(indent[1]) * 3}em`);
    if (cls.includes('ql-size-small')) styles.push('font-size:0.75em');
    if (cls.includes('ql-size-large')) styles.push('font-size:1.5em');
    if (cls.includes('ql-size-huge')) styles.push('font-size:2.5em');
    const fonts = {
      arial: 'Arial, Helvetica, sans-serif',
      'times-new-roman': '"Times New Roman", Times, serif',
      georgia: 'Georgia, serif',
      calibri: 'Calibri, Candara, sans-serif',
      verdana: 'Verdana, Geneva, sans-serif',
      tahoma: 'Tahoma, Geneva, sans-serif',
      'courier-new': '"Courier New", Courier, monospace',
    };
    Object.entries(fonts).forEach(([key, css]) => {
      if (cls.includes(`ql-font-${key}`)) styles.push(`font-family:${css}`);
    });
    if (!styles.length) return;
    const prev = el.getAttribute('style') || '';
    el.setAttribute('style', `${prev}${prev && !prev.endsWith(';') ? ';' : ''}${styles.join(';')}`);
  });
  return wrap.innerHTML;
}
